import apiClient from 'utilities/apiClient';

export const sendMail = (url, payload) => {
  return apiClient.patch(`${apiClient.Urls.printLable}/${url}`, payload);
};
